import { VisuallyHidden } from '@radix-ui/themes';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { toast } from 'sonner';
import { Image as ImageIcon, Copy, Check } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useState } from 'react';
interface ShareDialogProps {
  shareUrl: string;
  shareDialogOpen: boolean;
  setShareDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const ShareDialog: React.FC<ShareDialogProps> = ({
  shareUrl,
  shareDialogOpen,
  setShareDialogOpen,
}: ShareDialogProps) => {
  const [copied, setCopied] = useState(false);
  const appendNode2Body = (node) => {
    try {
      document.body.appendChild(node);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };
  const handleCopyUrl = () => {
    setCopied(true);
    const input = document.createElement('textarea');
    appendNode2Body(input);
    input.readOnly = true;
    input.value = location.href;
    input.select();

    try {
      const successful = document.execCommand('copy');
      document.body.removeChild(input);
      toast.success('Link copied to clipboard');
      setShareDialogOpen(false);
      setCopied(false);
      // toast.success('Video link copied to clipboard!');
      // return successful
    } catch (e) {
      toast.error('copy failed');
      setShareDialogOpen(false);
      setCopied(false);
      return false;
    }
  };
  {
    /* Share Dialog */
  }
  return (
    <Dialog open={shareDialogOpen} onOpenChange={setShareDialogOpen}>
      <DialogContent className="sm:max-w-md rounded-3xl">
        {/* 避免报错 */}
        <VisuallyHidden>
          <DialogTitle></DialogTitle>
        </VisuallyHidden>
        <DialogHeader>
          <DialogTitle>Share Video</DialogTitle>
          <DialogDescription>
            Copy the link below to share this video with others
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2">
          <div className="grid flex-1 gap-2">
            <Input readOnly value={shareUrl} className="rounded-2xl" />
          </div>
          <Button
            size="icon"
            onClick={handleCopyUrl}
            className="rounded-full h-10 w-10"
          >
            {copied ? (
              <Check className="h-4 w-4" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
          </Button>
        </div>
        {/* <DialogFooter className="sm:justify-start">
          <Button
            type="button"
            variant="outline"
            onClick={() => setShareDialogOpen(false)}
            className="rounded-full"
          >
            Close
          </Button>
        </DialogFooter> */}
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
